import {Panes, TextField} from '@management-ui/core';
import React from 'react';

export default function Fields({name = {}, prefix = '', multiplePanes = true, children}) {
  return (
    <Panes
      entity={name}
      prefix={prefix}
      panes={[
        {
          title: 'Details',
          fields: [
            <TextField
              name="label"
              prefix={prefix}
              label="Label"
              rules={{required: 'Please enter a label'}}
            />,
          ]
        }
      ]}
      title={multiplePanes ? null : 'Details'}
    >{children}</Panes>
  );
}
